import React, { useEffect } from 'react';
import { useAppAuth } from '../auth/appAuth';
import { useQueryClient } from 'react-query';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

const ClearAuthPage: React.FC = () => {
  const { logout } = useAppAuth();
  const queryClient = useQueryClient();

  useEffect(() => {
    const clearAuthAndLogout = () => {
      // Clear Auth0 cache from localStorage
      Object.keys(localStorage).forEach(key => {
        if (key.startsWith('@@auth0spajs@@')) {
          localStorage.removeItem(key);
        }
      });
      
      // Clear query cache as well
      queryClient.clear();
      
      // Force logout and redirect to login
      logout({ logoutParams: { returnTo: window.location.origin } });
    };

    // Small delay to show the loading message
    setTimeout(clearAuthAndLogout, 1000);
  }, [logout, queryClient]);

  return (
    <Box sx={{ 
      height: '100vh', 
      display: 'flex', 
      flexDirection: 'column',
      alignItems: 'center', 
      justifyContent: 'center',
      gap: 2
    }}>
      <CircularProgress />
      <Typography variant="h6" color="textSecondary">
        Clearing authentication cache...
      </Typography>
      <Typography variant="body2" color="textSecondary">
        You will be redirected to login shortly.
      </Typography>
    </Box>
  );
};

export default ClearAuthPage;
